"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NULL_ADDRESS = exports.ENS_DOMAIN = void 0;
exports.ENS_DOMAIN = 'fds';
exports.NULL_ADDRESS = '0x0000000000000000000000000000000000000000';
